module.exports = __webpack_public_path__ + "img/brushes-poster_cn.e0808b4.jpg";